// extracted by mini-css-extract-plugin
module.exports = {"optionRadio":"ProductOptionsRadio_optionRadio__mcoUo"};